// Copyright 2018 Sorama B.V.

import { autoinject, bindable, Loader } from "aurelia-framework";
import { IWorkflowModuleCatalog } from "catalogs/IWorkflowModuleCatalog";
import { LoaderExtensions } from "extensions/aurelia/LoaderExtensions";

interface ResultGroup {
    title: string;
    url: string;
    section?: string;
    searchtext?: string;
}

@autoinject
export class Results {
    private helpFilesLoaded = false;

    private fullResults: ResultGroup[] = [];
    private filteredResults: ResultGroup[] = [];
    private hasFilter = false;
    private filtered: ResultGroup[] = [];

    @bindable private filterText: string;
    @bindable private url: string;

    constructor(
        private readonly loader: Loader,
        private readonly moduleCatalog: IWorkflowModuleCatalog
    ) {
        this.filteredResults = [];
        this.hasFilter = false;
        this.loader = loader;

        Promise.all(
            moduleCatalog.getWorkflowModules().map((x) => {
                const url = x.modulePath + "Help.html";
                const promise = LoaderExtensions.exists(this.loader, url);

                return promise.then((y) => {
                    if (y) {
                        return {
                            title: x.title,
                            section: x.moduleType,
                            url: url,
                        };
                    }
                    return undefined;
                });
            })
        ).then((helpFiles) => {
            this.fullResults = helpFiles.filter((x) => x);
            this.helpFilesLoaded = true;
        });
    }

    private filterResultsTable(results: ResultGroup[], filter: string): ResultGroup[] {
        this.filtered = [];
        results.forEach((result) => {
            if (result.searchtext.indexOf(filter.toLowerCase()) !== -1) {
                this.filtered.push(result);
                this.url = "";
            }
        });
        return this.filtered.filter(this.uniqueArray);
    }

    private uniqueArray(value: ResultGroup, index: number, self: ResultGroup[]): boolean {
        return self.indexOf(value) === index;
    }

    private filterTextChanged(newValue: string, oldValue: string): void {
        //Load in the search words for each url in the fullResults array
        this.fullResults.forEach((x, index) => {
            const element = document.getElementById("url" + index);
            if (element) {
                x.searchtext = element.innerText.toLowerCase();
            }
        });

        if (newValue !== "") {
            this.hasFilter = true;
            this.filteredResults = this.filterResultsTable(this.fullResults, newValue);
        } else {
            this.hasFilter = false;
            this.filteredResults = [];
            this.url = "";
        }
    }

    private acceptResult(url: string): void {
        this.url = url;
    }
}
